exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-35cb8a5c]{position:relative}.centered[data-v-35cb8a5c]{position:absolute;top:50%;left:50%;transform:translate(-10%,-50%)}.text-dinamic[data-v-35cb8a5c]{font-size:23px;color:#000}.my-img[data-v-35cb8a5c]{width:100%;max-height:350px;border-radius:5px}@media only screen and (max-width:600px){.text-dinamic[data-v-35cb8a5c]{font-size:13.5px}}", ""]);

// exports
